import { delegateInit } from './BaseShape';
import { VerticalEdgedRectangle } from './VerticalEdgedRectangle';

const ENTITY_FIELD_NAME = 'ImportDeclaration';

export default delegateInit(VerticalEdgedRectangle, ENTITY_FIELD_NAME);



// WEBPACK FOOTER //
// ./src/render/svg/shapes/ImportDeclaration.js